module.exports = __webpack_public_path__ + "assets/player-account.84eaef56.svg";